var _defs, _clipPath, _rect, _use, _rect2, _rect3, _rect4, _use2, _use3, _use4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorldGenerator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -5 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "globe",
    fill: "blue",
    r: 4,
    cx: 0,
    cy: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    d: "M0 0 h3",
    clipPath: "url(#globe-clip)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud-partial",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    d: "M0 -3 h3",
    clipPath: "url(#globe-clip)"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "globe-clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#globe"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: -5,
    y: -5,
    fill: "black"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#globe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 15,
    x: -2,
    y: 1,
    transform: "rotate(45)",
    fill: "brown",
    clipPath: "url(#globe-clip)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 15,
    transform: "rotate(45)",
    fill: "yellow",
    clipPath: "url(#globe-clip)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 15,
    x: 2,
    y: -1,
    transform: "rotate(45)",
    fill: "orange",
    clipPath: "url(#globe-clip)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cloud",
    transform: "translate(-2, -2)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cloud",
    transform: "translate(-1, -1)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cloud-partial"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldGenerator);
export default __webpack_public_path__ + "static/media/world-generator.085cabc95048e4a3b42799e76bafa836.svg";
export { ForwardRef as ReactComponent };